import { useMemo } from 'react';
import { useNavigate, useI18n } from '@ywwwtseng/react-kit';
import { type FormElement, Form, validator } from '@/lib/react-form';
import { useAccountVerificationForm } from '@/hooks/useAccountVerificationForm';

export default function AccountVerificationScreen({
  params,
}: {
  params: { back?: string };
}) {
  const { t } = useI18n();
  const navigate = useNavigate();

  const form = useAccountVerificationForm();

  const elements = useMemo<{ row: FormElement[] }[]>(() => {
    return [
      {
        row: [
          {
            ui: 'description',
            text: t('account_verification.description'),
          },
        ],
      },
      {
        row: [
          {
            ui: 'text',
            label: t('account_verification.first_name'),
            name: 'first_name',
            validate: [
              validator.required({
                message: t('validation.required', {
                  name: t('account_verification.first_name'),
                }),
              }),
              validator.name({
                message: t('validation.invalid', {
                  name: t('account_verification.first_name'),
                }),
              }),
            ],
            props: {
              placeholder: t('account_verification.first_name'),
            },
          },
        ],
      },
      {
        row: [
          {
            ui: 'text',
            label: t('account_verification.last_name'),
            name: 'last_name',
            validate: [
              validator.required({
                message: t('validation.required', {
                  name: t('account_verification.last_name'),
                }),
              }),
              validator.name({
                message: t('validation.invalid', {
                  name: t('account_verification.last_name'),
                }),
              }),
            ],
            props: {
              placeholder: t('account_verification.last_name'),
            },
          },
        ],
      },
      {
        row: [
          {
            name: 'gender',
            ui: 'select',
            label: t('account_verification.gender'),
            validate: validator.required({
              message: t('validation.required', {
                name: t('account_verification.gender'),
              }),
            }),
            props: {
              options: [
                { name: t('account_verification.gender_male'), key: 'male' },
                {
                  name: t('account_verification.gender_female'),
                  key: 'female',
                },
                {
                  name: t('account_verification.gender_non_binary'),
                  key: 'non_binary',
                },
                {
                  name: t('account_verification.gender_other'),
                  key: 'other',
                },
              ],
            },
          },
        ],
      },
    ];
  }, [form.values]);

  return (
    <div className="flex flex-col justify-start w-full h-full gap-2 py-3 px-5">
      <Form
        name="account_verification"
        {...form}
        elements={elements}
        submit={{
          label: t('common.next'),
        }}
        onSubmit={() => {
          navigate('AccountVerification1', { params, type: 'replace' });
        }}
      />
    </div>
  );
}
